var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.permissionsArray.includes("can_manage_users")
    ? _c(
        "div",
        {
          staticClass: "admin-content-area",
          attrs: { id: "page-content-wrapper" }
        },
        [
          _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-header-top-container" }, [
              _c("div", { staticClass: "page-name" }, [_vm._v("Classes")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary waves-effect pull-right",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.AddClassMaster()
                    }
                  }
                },
                [_vm._v("Add")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _c("div", { staticClass: "forms-container default-bx-shadow" }, [
                _c(
                  "div",
                  { staticClass: "row no-margin" },
                  [
                    _c(
                      "draggable",
                      {
                        attrs: { options: _vm.dragOptions },
                        on: {
                          start: function($event) {
                            _vm.drag = true
                          },
                          change: _vm.changePosition
                        },
                        model: {
                          value: _vm.rows,
                          callback: function($$v) {
                            _vm.rows = $$v
                          },
                          expression: "rows"
                        }
                      },
                      _vm._l(_vm.rows, function(element, index) {
                        return _c(
                          "div",
                          {
                            key: "menu-" + element.id,
                            staticClass: "edit-menu",
                            attrs: { id: "menu-" + element.id }
                          },
                          [
                            _c("img", {
                              staticClass: "drag-handle",
                              attrs: { src: "/static/images/app-bar-icon.png" }
                            }),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(element.name))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "menu-actions" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "btn edit-btn-vvg waves-effect",
                                    attrs: {
                                      title: "Edit Class",
                                      to: {
                                        name: "UpdateClassMaster",
                                        params: { id: element.slug }
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-pencil",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn edit-btn-vvg waves-effect fa fa-trash",
                                    attrs: { title: "Delete Class" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteClassMaster(
                                          element.slug
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-trash-o",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("app-footer")
        ],
        1
      )
    : _c("div", [_c("no-permission")], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb03f03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb03f03","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClassMaster/ListMasterClass.vue
// module id = null
// module chunks = 